<template>
  <div class="main" :style="{background:pageConfig.backColor}">
    <div class="mainBox" :style="{backgroundImage:'url('+pageConfig.backImage+')'}">

      <div class="wrapbox" :style="{background:pageConfig.backColor}">
        <div class="conBox">
          <div class="wraper" v-for="(item, index) in ListArr" :key="index">
            <div class="activityBox" v-if="item.promotionProductVOS && item.promotionProductVOS.length>0"><img src="../assets/activity.png" alt=""></div>
            <div class="top" :class="{specialTop: isSpecialPriceProduct(item)}" @click="jumpDetail(item.id,item.isRecentExpiration)">
              <!-- <img :alt="item.goodsName | defaultName" :src="item.albumPics.split(',')[0] | defaultImage"> -->
              <img class="productImg" :alt="item.goodsName | defaultName" :src="item.pic | defaultImage">
              <template v-if="isSpecialPriceProduct(item)">
                <img class="speProBg" src="../assets/SpeProBg.png" alt="">
                <div class="speSave"><span>省</span>{{getSavePerUnit(item)}}元/{{getUnit(item)}}</div>
                <div class="spePriceFlag">
                  <span>活动价</span>
                  <b><i>￥</i>{{formatMoney(item._specialNumPrice.price)}} <i>起</i></b>
                </div>
                <div class="speReduce">
                  买{{item._specialNumPrice.num}}{{getUnit(item)}}立减{{getTotalSave(item)}}元
                </div>
              </template>
              <div v-if="getPromotionActivity(item)" class="promotionActivityBox">
                <img class="promotionBorder" src="../assets/goodsItem/mzjj_border.png" alt="">
                <div v-if="getPromotionActivity(item).redText" class="promotionRed">
                  <img class="promotionCheck" src="../assets/goodsItem/mzjj_check.png" alt="">
                  <span>{{ getPromotionActivity(item).redText }}</span>
                </div>
                <div v-if="getPromotionActivity(item).blueText" class="promotionBlue">
                  <span>{{ getPromotionActivity(item).blueText }}</span>
                </div>
              </div>
            </div>
            <h3 class="name" :title="item.name">{{item.name}}</h3>
            <div class="special">包装规格：({{item.specification}} )</div>
            <div class="special">件装规格：{{item.partSpecification}}</div>
            <div class="special"  v-if="item.quantity>=Number(item.minOrderNum)">效期优于：{{item.validDateFromat}}</div>
            <div class="specials"  v-if="item.quantity<Number(item.minOrderNum)">到货日期：{{item.deliveryTimeFormat==''?'暂无':item.deliveryTimeFormat}}</div>

            <div class="tagBox">
              <span v-if="isRecentExpirationProduct(item)" class="tag bgRed recentTag">近效期</span>
              <span  v-if="item.newStatus=='true'||item.newStatus==true"  class="tag bgGreen ">新品</span>
              <span  v-if="item.medicalInsuranceType>0"  class="tag bgBlue ">医保</span>
              <span  v-if="item.isReview==1" class="tag bgOrange">追溯码</span>
            </div>
            <div class="bottom" >
              <div class="price">
                <template v-if="isSpecialPriceProduct(item)">￥{{formatMoney(item._specialNumPrice.price)}} 起</template>
                <template v-else>￥{{item.price==="***"?"会员可见":item.price}}</template>
                <del class="delPrice"  v-if="item.quantity>=Number(item.minOrderNum) && item.numPrice && item.numPrice!=''" >
                  {{(item.price!=="***"?Number(item.price)>Number(item.memberPrice)?'':'￥'+item.memberPrice:'')| capitalize}}
                </del>
                <del class="delPrice"  v-else-if="item.numPrice && item.numPrice!=''" ></del>
                <del class="delPrice"  v-else >{{item.price!=="***"?Number(item.price)>=Number(item.memberPrice)?'':'￥'+item.memberPrice:''}}</del>
              </div>
              <div class="buy" v-if="item.quantity>=Number(item.minOrderNum)" @click="AddCart(item.id,item.minOrderNum,item.isRecentExpiration,item.goodNum)">
                <img class="bugImg" src="../assets/addCartIcon.png" alt="" />
              </div>
            </div>
            <div class="special" >指导零售价：￥{{item.originalPrice}}</div>
            <div class="clear"></div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    TagProduct
  } from '../api/product.js'

  export default {
    name: "List",
    data() {
      return {
        tagId: '',
        ListArr: [],
        // stylebg:'',
      };
    },
    computed: {
      pageConfig() {
        return this.ListArr[0] || {}
      }
    },
    created() {
      // 背景图变量
      // this.stylebg = require("../assets/anli.png");
      // this.stylebg ="https://new-3akx.oss-cn-zhangjiakou.aliyuncs.com//upload/20210312/a6d311bfc0c13b29bb88ab65403edeaf.png"

      this.tagId = this.$route.query.tagId
      // // 模拟数据
    //   let access_token="bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0ZW5hbnRfaWQiOiIxMDQ3MDQiLCJjb21wYW55X3R5cGUiOiIwMyIsInRoaXNfcm9sZV9pZCI6bnVsbCwidXNlcl9uYW1lIjoiMTgwMzUwNzQ3MzciLCJtZW1iZXJfbGV2ZWxfaWQiOi0xLCJmZF9mbGFnIjpmYWxzZSwiZW1wb3dlcl9zdGF0dXMiOjEsInJlYWxfbmFtZSI6IjE4MDM1MDc0NzM3IiwiYXVkaXRfc3RhdHVzIjo0LCJjbGllbnRfaWQiOiIzYWstcGMiLCJkaXNhYmxlX3N0YXR1cyI6MCwidXNlcl90eXBlIjoicGMiLCJyb2xlX2lkIjoiMTEyMzU5ODgxNjczODY3NTIwMiIsInNjb3BlIjpbImFsbCJdLCJvYXV0aF9pZCI6IiIsImlkX3R5cGUiOjIsIm1lbWJlcl9zdG9yZV9pZCI6MTM4Mzk2NTQ3NzQ5NzI1Nzk4NSwiZXhwIjoxODM3NzM5NjUyLCJqdGkiOiIyYmZiM2EwOS1kMjc4LTRhYWQtOTM1Ni1jOWM4MDQyOTZmOGEiLCJtZW1iZXJfaWQiOjEzODM5NjU0Nzc0NzYyODY0NjYsInN0b3JlX2lkIjotMSwiYXZhdGFyIjoiIiwiYXV0aG9yaXRpZXMiOlsidXNlciJdLCJyb2xlX25hbWUiOiJ1c2VyIiwibGljZW5zZSI6InBvd2VyZWQgYnkgYmxhZGV4IiwicG9zdF9pZCI6IiIsInVzZXJfaWQiOiIxMzgzOTY1NDc3NDM4NTM3NzI5Iiwibmlja19uYW1lIjoiMTgwMzUwNzQ3MzciLCJkZXBvc2l0X3N0YXR1cyI6MiwiZGVwdF9pZCI6IiIsImFjY291bnQiOiIxODAzNTA3NDczNyIsInN0YXR1cyI6MX0.aDmBpPB-eWlqbg_XLYFMEvpV1C8ON7Gif3MsVSvZWYI"
    //  TagProduct(access_token,2).then(res=>{
    //                   this.ListArr=res.data.data
    //               })
    },
    methods: {
      prepareProducts(list) {
        if (!Array.isArray(list)) return []
        return list.map(item => {
          return Object.assign({}, item, {
            _specialNumPrice: this.getLowestNumPrice(item.numPrice)
          })
        })
      },
      getLowestNumPrice(numPrice) {
        if (!numPrice) return null
        try {
          const list = typeof numPrice === 'string' ? JSON.parse(numPrice) : numPrice
          if (!Array.isArray(list)) return null
          const validList = list.filter(item => item && item.price !== undefined && !isNaN(Number(item.price)))
          if (!validList.length) return null
          return validList.reduce((min, item) => Number(item.price) < Number(min.price) ? item : min)
        } catch (error) {
          return null
        }
      },
      isSpecialPriceProduct(item) {
        return item && item.quantity >= Number(item.minOrderNum) && item._specialNumPrice
      },
      isRecentExpirationProduct(item) {
        if (!item) return false

        const producedDate = this.parseDate(item.producedDateFromat || item.producedDateFormat || item.producedDate)
        const validDate = this.parseDate(item.validDateFromat || item.validDateFormat || item.validDate)

        if (!producedDate || !validDate || validDate <= producedDate) {
          return item.isRecentExpiration === true || item.isRecentExpiration === 1 || item.isRecentExpiration === '1' || item.isRecentExpiration === 'true'
        }

        const now = new Date()
        now.setHours(0, 0, 0, 0)
        const twoYearsAfterProduced = this.addYears(producedDate, 2)
        const totalValidity = validDate.getTime() - producedDate.getTime()
        const remainingValidity = validDate.getTime() - now.getTime()

        if (validDate >= twoYearsAfterProduced) {
          return validDate < this.addMonths(now, 12)
        }

        return remainingValidity < totalValidity / 2
      },
      parseDate(value) {
        if (!value) return null
        if (value instanceof Date && !isNaN(value.getTime())) {
          const date = new Date(value)
          date.setHours(0, 0, 0, 0)
          return date
        }
        const text = String(value).trim()
        const match = text.match(/^(\d{4})[-/.年](\d{1,2})[-/.月](\d{1,2})/)
        if (!match) return null
        const year = Number(match[1])
        const month = Number(match[2]) - 1
        const day = Number(match[3])
        const date = new Date(year, month, day)
        if (date.getFullYear() !== year || date.getMonth() !== month || date.getDate() !== day) {
          return null
        }
        date.setHours(0, 0, 0, 0)
        return date
      },
      addYears(date, years) {
        const nextDate = new Date(date)
        nextDate.setFullYear(nextDate.getFullYear() + years)
        return nextDate
      },
      addMonths(date, months) {
        const nextDate = new Date(date)
        nextDate.setMonth(nextDate.getMonth() + months)
        return nextDate
      },
      formatMoney(value) {
        const money = Number(value)
        return isNaN(money) ? '0.00' : money.toFixed(2)
      },
      getSavePerUnit(item) {
        const price = item && item._specialNumPrice ? Number(item._specialNumPrice.price) : 0
        const save = Number(item.memberPrice) - price
        return this.formatMoney(save > 0 ? save : 0)
      },
      getTotalSave(item) {
        const num = item && item._specialNumPrice ? Number(item._specialNumPrice.num) : 0
        return this.formatMoney(Number(this.getSavePerUnit(item)) * num)
      },
      getUnit(item) {
        return item && item.unit ? item.unit : ''
      },
      getPromotionActivity(item) {
        const list = item && Array.isArray(item.promotionProductVOS) ? item.promotionProductVOS : []
        let description = ''
        for (let i = 0; i < list.length; i += 1) {
          const promotion = list[i]
          if (
            promotion &&
            (promotion.type === 'GIFT' || promotion.type === '赠品促销') && item.isGift == 0 &&
            typeof promotion.description === 'string' &&
            promotion.description.trim()
          ) {
            description = promotion.description.trim()
            break
          }
        }
        if (!description) return null
        const commaIndex = description.indexOf(',')
        const blueText = (commaIndex === -1 ? description : description.slice(0, commaIndex)).trim()
        const redText = (commaIndex === -1 ? '' : description.slice(commaIndex + 1)).trim()
        if (!blueText && !redText) return null
        return {
          blueText,
          redText
        }
      },
      // 点击跳转详情页   js跳转app
      jumpDetail(id, isRecentExpiration) {
        let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        let detailsData = {
          goods_id: id,
          isRecentExpiration: isRecentExpiration,
        }
        if (isiOS) {
          window.webkit.messageHandlers.jumpGoodsDetail.postMessage(detailsData)
        } else {
          this.$bridge.callHandler("jumpGoodsDetail", detailsData, res => {});
        }
      },
      // 点击加入购物车
      AddCart(id, minOrderNum, isRecentExpiration, goodNum) {
        // addShoppingCart(goods_id, isRecentExpiration,minOrderNum)
        let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        let datas = {
          goods_id: id,
          isRecentExpiration: isRecentExpiration,
          minOrderNum: minOrderNum,
          goodNum: goodNum
        };
        console.log(datas);
        if (isiOS) {
          window.webkit.messageHandlers.addShoppingCart.postMessage(datas)
        } else {
          this.$bridge.callHandler("addShoppingCart", datas, res => {});
        }
      },
      // 安卓app调js
      getAPPDate() {
        let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isiOS) {

        } else {
          this.$bridge.registerHandler("getToken", (data, responseCallback) => {
            console.log("安卓app主动调用js方法，传入数据:" + data);
            let access_token = "bearer " + data

            TagProduct(access_token, this.tagId).then(res => {
              this.ListArr = this.prepareProducts(res.data.data)
            })
            responseCallback(data);
          });
        }
      },
      getToken(token) {
        let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isiOS) {
          // 苹果app调取js方法
          console.log(token)
          let access_token = "bearer " + token
          TagProduct(access_token, this.tagId).then(res => {
            this.ListArr = this.prepareProducts(res.data.data)
          })
          //  alert("获取app响应数据:" + access_token);
        }
      },
    },
    //   注册方法
    mounted() {
      // 注册安卓方法
      window.getToken = this.getToken //ios使用
      this.getAPPDate();
    }
  };

</script>

<style scoped>
  .mainBox {
    /* background: url("../assets/discount.png") no-repeat; */
    background-repeat: no-repeat;
    background-size: 100%;
    padding-top: 3.27rem;
  }

  .wrapbox {
    padding: 0rem 0.12rem 0.12rem;
    width: calc(100% - 0.24rem);
    background: red;
    position: relative;
    height: calc(100% - 1.6rem);
  }

  .conBox {
    width: 100%;
    position: relative;
    top: -1.4rem;
  }

  .conBox>.wraper:nth-child(even) {
    margin-left: 0.09rem;
  }

  .wraper {
    padding: 0.05rem 0.08rem 0.08rem;
    /* width: 1.4rem; */
    width: calc(50% - 0.205rem);
    height: 2.9rem;
    box-sizing: content-box;
    float: left;
    background: #fff;
    margin-bottom: 0.08rem;
    position: relative;
  }
.activityBox{
  position:absolute;
  left: 0;
  top: 0;
  z-index: 10;
}
.activityBox img{
  width: 0.3rem;
  height: auto;
  display: block;
}

  .top {
    margin: 0 auto;
    width: 1.2rem;
    height: 1.2rem;
    position: relative;
    overflow: hidden;
  }

  .top .productImg {
    display: inline-block;
    width: 100%;
    height: 100%;
  }

  .specialTop {
    margin-bottom: 0.02rem;
    background: #fff;
  }

  .speProBg {
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    pointer-events: none;
  }

  .speSave {
    position: absolute;
    top: 0.05rem;
    right: 0.02rem;
    z-index: 3;
    color: #fff;
    font-size: 0.08rem;
    line-height: 0.12rem;
    font-weight: bold;
    white-space: nowrap;
    transform-origin: right top;
  }

  .speSave span {
    display: inline-block;
    font-size: 0.09rem;
    color: rgb(255, 238, 164);
  }

  .spePriceFlag {
    position: absolute;
    left: 0.02rem;
    bottom: 0.01rem;
    z-index: 3;
    width: 0.48rem;
    height: 0.31rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  .spePriceFlag span {
    display: inline-block;
    min-width: 0.38rem;
    height: 0.18rem;
    padding: 0 0.03rem;
    border-radius: 0.09rem;
    background: #fff5cf;
    color: #ff3333;
    font-size: 0.09rem;
    line-height: 0.18rem;
    text-align: center;
    font-weight: bold;
  }

  .spePriceFlag b {
    display: inline-block;
    margin-top: 0.02rem;
    width: 0.58rem;
    color: #fff;
    font-size: 0.11rem;
    line-height: 0.1rem;
    font-weight: bold;
  }

  .spePriceFlag b i {
    font-style: normal;
    font-size: 0.08rem;
  }

  .speReduce {
    position: absolute;
    right: 0.08rem;
    bottom: 0.02rem;
    z-index: 3;
    color: #fff;
    font-size: 0.07rem;
    line-height: 0.1rem;
    white-space: normal;
  }

  .promotionActivityBox {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 5;
    pointer-events: none;
  }

  .promotionBorder {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .promotionRed {
    position: absolute;
    left: 0.05rem;
    bottom: 0.18rem;
    display: inline-flex;
    width: -webkit-fit-content;
    width: fit-content;
    max-width: calc(100% - 0.1rem);
    height: 0.17rem;
    line-height: 0.17rem;
    padding: 0 0.07rem 0 0.16rem;
    box-sizing: border-box;
    align-items: center;
    color: #fff;
    font-size: 0.07rem;
    font-weight: 400;
    white-space: nowrap;
    background: url("../assets/goodsItem/mzjj_red.png") no-repeat center center;
    background-size: 100% 100%;
    z-index: 3;
  }

  .promotionCheck {
    position: absolute;
    left: 0.03rem;
    top: 45%;
    width: 0.1rem;
    height: 0.1rem;
    transform: translateY(-50%);
  }

  .promotionBlue {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 0.28rem;
    line-height: 0.13rem;
    padding: 0 0.03rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 0.09rem;
    font-weight: 700;
    text-align: center;
    white-space: nowrap;
    text-shadow: 0 0.01rem 0.02rem rgba(0, 0, 0, 0.35);
    background: url("../assets/goodsItem/mzjj_blue.png") no-repeat center center;
    background-size: 100% 100%;
    z-index: 2;
  }

  .promotionBlue span {
    display: inline-block;
    max-width: 100%;
    font-weight: bold;
    white-space: nowrap;
    transform: translateY(0.03rem) skewX(-5deg);
    transform-origin: center center;
  }

  .name {
    color: #333;
    font-size: 0.12rem;
    line-height: 0.21rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
  }

  .special {
    color: #999;
    font-size: 0.11rem;
    line-height: 0.2rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
  }
  .specials{
    color: #FF3434;
    font-size: 0.11rem;
    line-height: 0.2rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
  }
  .tagBox{
    display: flex;
    flex-wrap: wrap;
    gap: 0.04rem 0.06rem;
    min-height: 0.25rem;
    margin-top: 0.04rem;
}
.tag{
   width:0.36rem;
   border-radius:0.05rem;
   text-align: center;
    height:0.2rem;
    line-height: 0.24rem;
    font-size:0.11rem;
    display: inline-block;
    flex: 0 0 auto;
}

          .bgRed{
             background-color:#fff1f0;
             border: 1px solid #FF3434;
             color:#FF3434;
          }
          .recentTag{
             width:0.44rem;
          }

         
          .bgBlue{
              background-color: #d9e6f7;
              border: 1px solid #3485FF;
              color:#3485FF;
          }
          .bgGreen{
            background-color:  #f3fcf2;
            border: 1px solid  #52C41A;
            color:#52C41A;
          }
          .bgOrange{
             background-color:#f3fcf2;
               border: 1px solid  #FF7A45;
               color:#FF7A45;
          }
  .bottom {
    /* margin-top: 0.06rem;
    margin-bottom: 0.06rem; */
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .price {
    color: #ff3333;
    font-size: 0.14rem;
    font-weight: bold;
  }
  .delPrice{
    font-size: 0.12rem;
    color: #929598;
    font-weight: normal;
  }
  .buy {
    /* background: #ff3333; */
    /* color: #fff; */
    font-size: 0.1rem;
    /* padding: 0.02rem; */
  }
  .bugImg{
      width: 0.22rem;
      height: 0.22rem;
    }

  .clear {
    clear: both;
  }

</style>



// WEBPACK FOOTER //
// src/components/NewDiscount.vue